/**
 * Client-side mirrors of the caps `POST /api/v1/contacts/update` enforces.
 *
 * These exist because the endpoint REJECTS an over-long value rather than truncating it
 * (`validateContactPatch` in the server's `crm/contactWriteRules.ts`), and it does so
 * after the realtor has already typed the text. A 400 at that point tells them nothing
 * they can act on and loses what they wrote — so the input stops the keystroke instead.
 *
 * KEEP IN SYNC with `MAX_TEXT_LENGTH` / `MAX_NAME_LENGTH` in
 * `webot-server/server/api/services/crm/contactWriteRules.ts`. There is no build-time
 * link between the two files; a mismatch shows up as a save that fails on a value the
 * form was happy to accept.
 *
 * On the numbers: measured across the mirrored corpus (47,726 contacts, 11,406 carrying
 * a note) the LONGEST `additionalNotes` is 540 characters, p50 is 19 and p99 is 294. So
 * 5,000 is roughly nine times the real maximum and no realtor should ever reach it —
 * these are guard rails against a paste, not a budget anyone is spending.
 */

/** `additionalNotes` — the free-text "על הלקוח" field. */
export const CONTACT_NOTES_MAX_LENGTH = 5_000;

/** Names, email, origin, sub-status — every short single-line text field. */
export const CONTACT_NAME_MAX_LENGTH = 200;
